import { getNonStickyTop } from '@marriott/mi-store-utils';
import { toRem } from '@marriott/mi-ui-library';

export type SkeletonLoaderBreakpoint = 'xs' | 'sm' | 'md' | 'lg';

const BREAKPOINTS: SkeletonLoaderBreakpoint[] = ['xs', 'sm', 'md', 'lg'];

/** NGSF A/B scope is en-US homepage where global-nav is always present. */
const HAS_GLOBAL_NAV = true;

const toTopCss = (breakpoint: SkeletonLoaderBreakpoint, isNorthStar: boolean): string =>
  toRem(getNonStickyTop(breakpoint, isNorthStar, HAS_GLOBAL_NAV));

const buildVariantTopCss = (isNorthStar: boolean): Record<SkeletonLoaderBreakpoint, string> =>
  BREAKPOINTS.reduce((acc, bp) => {
    acc[bp] = toTopCss(bp, isNorthStar);
    return acc;
  }, {} as Record<SkeletonLoaderBreakpoint, string>);

/** BAU homepage top offsets (default). */
export const skeletonBauTopCss = buildVariantTopCss(false);

/** Polaris homepage top offsets (applied via `body.polaris-page` in styles). */
export const skeletonPolarisTopCss = buildVariantTopCss(true);

/**
 * Polaris xs top mirrors `StickyComponentWrapper.resolveXsTopOffset` tab-title wrap
 * handling so the skeleton lands where the real SearchForm will.
 */
export const skeletonPolarisXsTopCss = `calc(${skeletonPolarisTopCss.xs} + var(--tab-title-wrap-offset, ${toRem(36)}))`;
export const skeletonPolarisXsTopCssWide = `calc(${skeletonPolarisTopCss.xs} + var(--tab-title-wrap-offset, 0px))`;
